export default __webpack_public_path__ + "static/media/Red0001.65c7693a.png";